// Restaurant representative item mapping
export const restaurantLogos = {
  "Delicious Bake": "/assets/items/item2.jpeg",
  "Little Baker World": "/assets/items/item5.jpeg",
  "Ms Cutie Cookies": "/assets/items/item1.jpeg",
  NuoNuo: "/assets/items/item3.jpeg",
  "Sunrise Bakery": "/assets/items/item4.jpeg",
  "Golden Crust": "/assets/items/item6.jpeg",
  "Sweet Dreams": "/assets/items/item7.jpeg",
  "Morning Glory": "/assets/items/item8.jpeg",
};

export const restaurantItems = {
  // Original seed restaurants (existing)
  "Delicious Bake": "/assets/restaurants/delicious_bake/item3.jpeg",
  "Little Baker World": "/assets/restaurants/little_baker_world/item1.jpeg",
  "Ms Cutie Cookies": "/assets/restaurants/ms_cutie_cookies/item1.jpeg",
  NuoNuo: "/assets/restaurants/nuo_nuo/item3.jpeg",
  "today.sandwich": "/assets/restaurants/today.sandwich/item1.jpeg",

  // Additional seed restaurants (new - add images later)
  "Cake Express Hub": "/assets/restaurants/cake_express_hub/logo.jpeg",
  "Mini choc": "/assets/restaurants/mini_choc/logo.jpeg",
  "CJ Bakery Shop": "/assets/restaurants/cj_bakery_shop/logo.jpeg",
  "Sweet.bitssss": "/assets/restaurants/sweet_bitssss/logo.jpeg",
  "XR simple bake studio":
    "/assets/restaurants/xr_simple_bake_studio/logo.jpeg",
  "KIE Patisserie": "/assets/restaurants/kie_patisserie/logo.jpeg",

  // Featured restaurant
  "Artisan Coffee Roasters":
    "/assets/restaurants/artisan_coffee_roasters/logo.jpeg",

  // New restaurants from seed-new-restaurants.js (missing ones)
  "KIE Patisserie (Cake)": "/assets/restaurants/kie_patisserie_cake/logo.jpeg",
  Thelicious: "/assets/restaurants/thelicious/logo.jpeg",
  "Michelle's Traditional Bake (Ang Ku Kuih)":
    "/assets/restaurants/michelles_traditional_bake_angkukuih/logo.jpeg",
  "Michelle's Traditional Bake (Egg Tart)":
    "/assets/restaurants/michelles_traditional_bake_eggtart/logo.jpeg",
};

// Default item fallback
export const defaultRestaurantItem =
  "/assets/restaurants/delicious_bake/item1.jpeg";

// Helper function to get restaurant representative item
export const getRestaurantItem = (restaurantName) => {
  return restaurantItems[restaurantName] || defaultRestaurantItem;
};

// Helper function to get all restaurant names with items
export const getRestaurantNamesWithItems = () => {
  return Object.keys(restaurantItems);
};

// Helper function to check if restaurant has custom item
export const hasCustomItem = (restaurantName) => {
  return restaurantName in restaurantItems;
};
